import React from 'react';
import { hydrate, render } from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');
const helmetContext = {};

// Routes react-snap actually prerenders (from your build log)
const prerendered = ['/', '/menu', '/about', '/weeklymenu', '/events', '/menu/indian', '/menu/goan'];
const path = window.location.pathname.replace(/(.)\/$/, '$1');

const app = (
  <HelmetProvider context={helmetContext}>
    <App />
  </HelmetProvider>
);

if (rootElement.hasChildNodes() && prerendered.includes(path)) {
  hydrate(app, rootElement);
} else {
  rootElement.innerHTML = '';
  render(app, rootElement);
}

reportWebVitals();